import { useEffect, useState } from "react";

export default function ModalCamisa({ camisa, onClose }) {
  const [imagemAtiva, setImagemAtiva] = useState(camisa.imagens[0]);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const telefone = "5541999716047";
  const siteUrl = window.location.origin;
  const imagemPrincipal = `${siteUrl}${camisa.imagens[0]}`;

  const mensagem = encodeURIComponent(
    `
Olá Piazada dos Mantos!
Tenho interesse no modelo:

${camisa.nome}

Imagem do modelo:
${imagemPrincipal}

Poderia me informar a disponibilidade?
`.trim()
  );

  const linkWhatsapp = `https://wa.me/${telefone}?text=${mensagem}`;

  const indexAtual = camisa.imagens.indexOf(imagemAtiva);

  const proximaImagem = () => {
    const novoIndex = (indexAtual + 1) % camisa.imagens.length;
    setImagemAtiva(camisa.imagens[novoIndex]);
  };

  const imagemAnterior = () => {
    const novoIndex =
      (indexAtual - 1 + camisa.imagens.length) % camisa.imagens.length;
    setImagemAtiva(camisa.imagens[novoIndex]);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="modal-close"
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        >
          ✕
        </button>

        <div className="modal-content modal-scroll">
          <div className="modal-image">
            <button
              type="button"
              className="nav prev"
              onClick={(e) => {
                e.stopPropagation();
                imagemAnterior();
              }}
            >
              ‹
            </button>

            <img src={imagemAtiva} alt={camisa.nome} />

            <button
              type="button"
              className="nav next"
              onClick={(e) => {
                e.stopPropagation();
                proximaImagem();
              }}
            >
              ›
            </button>
          </div>

          <div className="modal-info">
            <h2>{camisa.nome}</h2>

            <div className="modal-thumbs">
              {camisa.imagens.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt=""
                  className={img === imagemAtiva ? "active" : ""}
                  onClick={(e) => {
                    e.stopPropagation();
                    setImagemAtiva(img);
                  }}
                />
              ))}
            </div>

            <a
              href={linkWhatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-whatsapp"
              onClick={(e) => e.stopPropagation()}
            >
              Comprar no WhatsApp
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
